/**
 * Pondok icon — stylized traditional Indonesian stilted hut.
 * Drop-in replacement for lucide's `Palmtree`: accepts `className`, `strokeWidth`, `size`.
 * Matches the PWA icon design.
 */
export default function PondokIcon({ className = "", strokeWidth = 1.8, size, ...rest }) {
  const sizeProps = size ? { width: size, height: size } : {};
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...sizeProps}
      {...rest}
    >
      {/* Outer roof — pointed with wide eaves */}
      <path d="M12 2.5 L4 11.5 L6 12.5 L18 12.5 L20 11.5 Z" fill="currentColor" fillOpacity="0.0" />
      {/* Roof outline */}
      <path d="M12 2.5 L4 11.5 L20 11.5 Z" />
      {/* Inner roof accent (layered roof) */}
      <path d="M12 5.5 L7 10.5 L17 10.5 Z" />
      {/* Body / wall */}
      <path d="M7 12.5 L7 17.5 L17 17.5 L17 12.5" />
      {/* Door (arched) */}
      <path d="M10.5 17.5 L10.5 14.5 Q12 13.5 13.5 14.5 L13.5 17.5" />
      {/* Stilts / panggung */}
      <line x1="9" y1="17.5" x2="9" y2="20" />
      <line x1="15" y1="17.5" x2="15" y2="20" />
      {/* Ground line */}
      <line x1="4" y1="20" x2="20" y2="20" />
    </svg>
  );
}
